import { useTranslation } from "react-i18next";
import { Link } from "src/components/Link";
import { ActionBanner } from "src/components/ActionBanner";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { PATHNAMES } from "src/constants/routes";
import { ReactComponent as PlusIcon } from "src/assets/icons/plus.svg";
import { noMyInquiriesBannerTrns } from "./trns";

export const NoMyInquiriesBanner = () => {
  const { t } = useTranslation();

  return (
    <ActionBanner className="!gap-3" title={t(noMyInquiriesBannerTrns.title)}>
      <p className="font-medium">{t(noMyInquiriesBannerTrns.description)}</p>

      <Link href={PATHNAMES.CREATE_INQUIRY}>
        <Button
          variant={ButtonVariants.SECONDARY}
          className="gap-2 h-10 px-5 py-2 !text-black-base font-medium"
        >
          <PlusIcon />
          {t(noMyInquiriesBannerTrns.addInquiryButton)}
        </Button>
      </Link>
    </ActionBanner>
  );
};
